<script>
import { Doughnut } from 'vue-chartjs'
const options = {
  responsive: true,
  maintainAspectRatio: false,
  animation: {
    animateRotate: false
  }
}
export default {
  extends: Doughnut,
  props:['chartData'],
  mounted () {
    this.renderChart(this.chartData, options)
  },
  methods: {
    update() {
      this.$data._chart.destroy()
      this.renderChart(this.chartData, options)
    }
  },
  watch: {
    chartData() {
      this.update()
    }
  },
};
</script>
